import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'list': [],
  'filteredList': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const filterList = (list, value) => {
  return [...list].filter((element) =>
    [
      element.location || '',
      element.pickingZoneName || 'Sin zona',
    ].some((text) =>
      text.trim().toLowerCase().startsWith(value.trim().toLowerCase()) || value === ''
    )
  );
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const locations = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_LOCATIONS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_LOCATIONS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
      'page': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_LOCATIONS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
      'page': [],
    }),
    [ActionTypes.CHANGE_LOCATIONS_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterText': action.payload,
    }),
    [ActionTypes.FILTER_LOCATIONS]: (state, action) => ({
      ...state,
      'filteredList': [...filterList(state.list, action.payload)],
      'pageNumber': 0,
      'page': [...getPage([...filterList(state.list, action.payload)], 0, state.pageSize)],
    }),
    [ActionTypes.CHANGE_LOCATIONS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.filteredList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_LOCATIONS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.filteredList, 0, action.payload)],
    }),
  })(state, action);
};
